<template>
  <div class="page">
    <box>
      <el-form label-position="right" label-width="100px" class="EL-Form">
        <el-col :lg="5" :xl="5">
          <el-form-item label="通道编号" class="EL-Form-Item">
            <el-select v-model="mainSearch.whCode" placeholder="请选择" clearable="clearable" filterable>
              <el-option v-for="item in warehouseList" :key="item.whId" :value="item.whCode" :label="item.whCode + '-' + item.whName"></el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :lg="5" :xl="5">
          <el-form-item label="库位" class="EL-Form-Item">
            <el-input v-model="mainSearch.laCode" placeholder="请输入" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :lg="5" :xl="5">
          <el-form-item label="箱号" class="EL-Form-Item">
            <el-input v-model="mainSearch.boxBarcode" placeholder="请输入" @change="saveSearch()">
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :lg="5" :xl="5">
          <el-form-item label="物料编号" class="EL-Form-Item">
            <el-input v-model="mainSearch.matCode" placeholder="请输入" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :lg="5" :xl="5">
          <el-form-item label="外协单号" class="EL-Form-Item">
            <el-input v-model="mainSearch.soCode" placeholder="请输入">
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :lg="5" :xl="5">
          <el-form-item label="状态" class="EL-Form-Item">
            <el-select v-model="mainSearch.soStatus">
              <el-option label="默认(进行中,发货完成)" value="20,80"></el-option>
              <el-option label="进行中" value="20"></el-option>
              <!--<el-option label="出库完成" value="30"></el-option>
               <el-option label="拣配完成" value="60"></el-option> -->
              <el-option label="发货完成" value="80"></el-option>
              <!-- <el-option label="收货完成" value="40"></el-option> -->
              <el-option label="关闭" value="50"></el-option>
            </el-select>
          </el-form-item>
        </el-col>


        <el-col :lg="5" :xl="5">
          <el-form-item label="开始日期" class="EL-Form-Item">
            <el-date-picker v-model="mainSearch.date[0]" value-format="yyyy-MM-dd" type="date" placeholder="开始日期" :picker-options="pickerOptions0"></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :lg="5" :xl="5">
          <el-form-item label="结束日期" class="EL-Form-Item">
            <el-date-picker v-model="mainSearch.date[1]" value-format="yyyy-MM-dd" type="date" placeholder="结束日期" :picker-options="pickerOptions"></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :lg="4" :xl="4">
          <el-form-item class="btn-edit-delete EL-Form-Item">
            <el-button class="btn-t-edit" @click="saveSearch">查询</el-button>
            <el-button class="btn-t-delete" @click="resetMain">重置</el-button>
          </el-form-item>
        </el-col>
      </el-form>
    </box>
    <box fill>
      <plabel text="仓库外协">
        <el-button v-authority="'BACK_MENU6_M6_B1'" class="btn-t-edit" @click="insertdialogShow()">新增叫料</el-button>
        <el-button v-authority="'BACK_MENU6_M6_B2'" class="btn-t-edit" @click="importInShow = true">批量上传</el-button>
        <el-button v-authority="'BACK_MENU6_M1_B4'" class="btn-t-edit" type="primary" @click="closeOutsourcing()">关闭外协单</el-button>
        <el-button v-authority="'BACK_MENU1_M2_B2'" class="btn-t-edit" @click="isReceivingDetails = true">工单同步</el-button>
        <!--<el-button v-authority="'BACK_MENU1_M2_B3'" class="btn-t-edit" type="primary" @click="prints()">单据打印</el-button>-->
        <el-button v-authority="'BACK_MENU1_M2_B4'" :loading="downloadLoading" class="btn-t-edit" type="primary" @click="downLoadFile()">导出EXCEL</el-button>
      </plabel>
      <h-table :style="$popups.harvestRecordStyle(0.56)" :headerCellStyle="mainSearch.headerCellStyle" style="flex: 1" :data="mainData.data" pagination nowPage.sync="mainData.nowPage" :pageSize.sync="mainData.pageSize" :total.sync="mainData.total" @selectionChange="selectAllMain">
        <el-table-column type="selection" align="center"></el-table-column>
        <el-table-column label="外协单号" prop="soCode" align="center">
        </el-table-column>
        <el-table-column label="外协供应商" prop="laOutsouceCode" align="center">
        </el-table-column>
        <el-table-column label="状态" prop="soStatus" align="center">
          <template slot-scope="scope">
            <div v-if="scope.row.soStatus == '20'">进行中</div>
            <div v-if="scope.row.soStatus == '30'">出库完成</div>
            <!--<div v-if="scope.row.soStatus == '60'">发货完成</div>-->
            <div v-if="scope.row.soStatus == '40'">收货完成</div>
            <div v-if="scope.row.soStatus == '80'">发货完成</div>
            <div v-if="scope.row.soStatus == '50'">关闭</div>
          </template>
        </el-table-column>
        <el-table-column label="创建人" prop="person" palign="center">
        </el-table-column>
        <el-table-column label="创建时间" prop="createTime" align="center">
        </el-table-column>
        <el-table-column label="操作" align="center" width="300px">
          <template slot-scope="scope">
            <el-button v-authority="'BACK_MENU6_M1_B7'" class="btn-t-edit" type="primary" @click="detailsDialogShow = true,getOutsourceDetail(scope.row.soCode,scope.row.soStatus)">详情</el-button>

            <!-- <el-button v-authority="'XCMENUCODE'" class="btn-t-edit" type="primary" @click="scanOutsource(scope.row.soCode)" :disabled="scope.row.soStatus==30 ? false:true">外协接收</el-button>
            <el-button v-authority="'XCMENUCODE'" class="btn-t-edit" type="primary" @click="DialogReceptionShows = true,getOutsourcePrint(scope.row.soCode)">接收记录</el-button> -->
          </template>
        </el-table-column>
      </h-table>
    </box>

    <!-- 新增叫料 -->
    <el-dialog title="新增叫料" :visible.sync="dialogShow" class="fromDialog" :style="$popups.popups(0.8, 0.9)" :close-on-click-modal="false" :show-close="false">
      <div style="overflow: hidden; padding-bottom: 10px">
        <el-form label-position="right" label-width="80px">
          <el-col :lg="5" :xl="5">
            <el-form-item label="通道" class="EL-Form-Item">
              <el-select v-model="insertData.whCode" filterable @change="changeWhCode();">
                <el-option v-for="item in warehouseList" :key="item.whId" :value="item.whCode" :label="item.whCode + '-' + item.whName"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="5" :xl="5">
            <el-form-item label="需求时间" class="EL-Form-Item">
              <el-date-picker v-model="insertData.requireTime" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" placeholder="选择日期时间" @change="topFunction"> </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :lg="5" :xl="5">
            <el-form-item label="是否紧急" class="EL-Form-Item">
              <el-select v-model="insertData.topFlag" placeholder="请选择" clearable="clearable" @change="topMessages(insertData.topFlag)">
                <el-option label="是" :value="true" />
                <el-option label="否" :value="false" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="5" :xl="5" v-if="insertData.topFlag">
            <el-form-item label="紧急原因" class="EL-Form-Item">
              <el-select v-model="insertData.topMessage" filterable>
                <el-option v-for="item in insertDataList.resultList" :key="item.wtId" :value="item.wtName" :label="item.wtName"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="4" :xl="4" style="float: right">
            <el-button class="btn-t-edit" @click="getBomList()">查询</el-button>
          </el-col>
          <el-col :lg="5" :xl="5">
            <el-form-item label="叫料方式" class="EL-Form-Item">
              <el-select v-model="insertData.pmType" @change="(insertDataList.bomList = []), changePmType()">
                <el-option value="ORDER" label="工单叫料"></el-option>
                <el-option value="BOM" label="BOM叫料"></el-option>
                <el-option value="MATERIAL" label="物料叫料"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="5" :xl="5" v-if="insertData.pmType == 'ORDER'">
            <el-form-item label="工单" class="EL-Form-Item">
              <el-select v-model="insertData.opCode" filterable @change="changeOrder($event)">
                <el-option v-for="item in insertDataList.orderList" :key="item.opId" :value="item.opCode" :label="item.opCode"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="5" :xl="5" v-if="insertData.pmType != 'MATERIAL'">
            <el-form-item label="成品编号" v-if="insertData.pmType == 'BOM'" class="EL-Form-Item">
              <el-select v-model="insertData.prodCode" filterable clearable>
                <el-option v-for="item in insertDataList.bomList" :key="item.bpId" :value="item.prodCode" :label="item.prodCode"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="成品编号" v-if="insertData.pmType == 'ORDER'" class="EL-Form-Item">
              <el-input v-model="insertData.prodCode" placeholder="请输入" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :lg="5" :xl="5" v-if="insertData.pmType == 'MATERIAL'">
            <el-form-item label="物料编号" class="EL-Form-Item">
              <el-select v-model="insertData.matCode" filterable clearable remote :remote-method="remoteMethod" :loading="loading" @change="remoteMethod">
                <el-option v-for="item in materialList" :key="item.mtId" :label="item.mtCode" :value="item.mtCode"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="5" :xl="5" v-if="insertData.pmType == 'ORDER'">
            <el-form-item label="工单数量" class="EL-Form-Item">
              <el-input v-model="insertData.jihuaquan" placeholder="请输入" :disabled="true" oninput="value=value.replace(/[^\d]/g,'')"></el-input>
            </el-form-item>
          </el-col>
          <el-col :lg="5" :xl="5" v-if="insertData.pmType != 'MATERIAL'">
            <el-form-item label="叫料数量" class="EL-Form-Item">
              <el-input v-model="insertData.jiaoliaoQuan" placeholder="请输入" oninput="value=value.replace(/[^\d]/g,'')"></el-input>
            </el-form-item>
          </el-col>
          <el-col :lg="5" :xl="5" >
            <el-form-item label="班次" class="EL-Form-Item">
              <el-select v-model="insertData.shift">
                <el-option value="早班" >早班</el-option>
                <el-option value="晚班" >晚班</el-option>
                <el-option value="中班" >中班</el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="1" :xl="0" class="redx">
            *
          </el-col>
          <el-col :lg="5" :xl="5">

             <el-form-item label="物料类型" class="EL-Form-Item ">

              <el-select v-model="insertData.materialType">
                <el-option value="套圈" >套圈</el-option>
                <el-option value="配件" >配件</el-option>
              </el-select>
            </el-form-item>
          </el-col>
<!--
          <el-col :lg="5" :xl="5">

            <el-form-item label="委外库位" class="EL-Form-Item ">

              <el-select v-model="insertData.wxFlag">
                <el-option value="0" label="否" >否</el-option>
                <el-option value="1"  label="是" >是</el-option>
              </el-select>
            </el-form-item>
          </el-col>-->
          <el-col :lg="5" :xl="5">

            <el-form-item label="供应商" class="EL-Form-Item ">
              <el-select v-model="insertData.wxCode" filterable placeholder="请选择" clearable="clearable">
                <el-option v-for="item in laCodeList" :key="item.whId" :value="item.lcCode" :label="item.lcCode">{{item.lcCode}}--{{item.lcName}}</el-option>
              </el-select>

            </el-form-item>
          </el-col>


          <!-- <el-col :lg="5" :xl="5">
            <el-form-item label="需求订单" class="EL-Form-Item">
              <el-input v-model="insertData.requireOrder" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
          <el-col :lg="5" :xl="5">
            <el-form-item label="库区" class="EL-Form-Item">
              <el-select v-model="insertData.whArea" placeholder="请选择">
                <el-option v-for="item in insertDataList.warehouseAreaList" :key="item.id" :label="item.whAreaName" :value="item.whAreaCode"></el-option>
              </el-select>
            </el-form-item>
          </el-col> -->
        </el-form>
      </div>
      <div>
        <h-table :style="$popups.harvestRecordStyle(0.55)" :headerCellStyle="mainData.headerCellStyle" :data="insertDataList.matList" :row-class-name="tableRowClassName">
          <el-table-column label="通道编号" prop="whCode" align="center"> </el-table-column>
          <el-table-column label="工单编号" prop="opCode" align="center" v-if="insertData.pmType == 'ORDER'"> </el-table-column>
          <el-table-column label="物料编号" prop="matCode" align="center"> </el-table-column>
          <el-table-column label="物料描述" prop="matName" align="center"> </el-table-column>
          <el-table-column label="工单数量" prop="produceQuan" align="center" v-if="insertData.pmType == 'ORDER'"> </el-table-column>
          <el-table-column label="物料需求总量" prop="matCountQuan" align="center"> </el-table-column>
          <el-table-column label="已申请总量" prop="matCallQuan" align="center" v-if="insertData.pmType == 'ORDER'"> </el-table-column>
          <el-table-column label="BOM用量" prop="bomQuan" align="center"> </el-table-column>
          <el-table-column label="剩余需求数量" prop="matQuan" align="center"> </el-table-column>
          <el-table-column label="实际需求数量" prop="matRealQuan" align="center" width="100px">
            <template slot-scope="scope">
              <el-input v-model="scope.row.matRealQuan" placeholder="请输入" oninput="value=value.replace(/[^\d]/g,'')"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="当前库存" prop="whQuan" align="center">
            <template slot-scope="scope">
              <el-button size="small" @click="getWhDetails(scope.row)">{{ scope.row.whQuan }}</el-button>
            </template>
          </el-table-column>
          <el-table-column label="待检库存" prop="waitQuan" align="center"></el-table-column>
          <el-table-column label="规值" prop="matSpecs" align="center"> </el-table-column>
          <el-table-column label="最小包装量" prop="minBoxNum" align="center"> </el-table-column>
          <el-table-column label="整托数量" prop="wholeNum" align="center"> </el-table-column>
          <!-- <el-table-column label="需求时间" prop="requireTime" align="center"> </el-table-column> -->
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button @click="delList(scope.row.index)" class="btn-t-delete">删 除</el-button>
            </template>
          </el-table-column>
        </h-table>
        <br>
      </div>
      <div slot="footer" class="dialog-footer footer-bottom">
        <el-button @click="insertdialogClose" type="info" class="btn-t-info">关 闭</el-button>
        <el-button :loading="insertStockProductMats" class="btn-t-edit" @click="insertStockProductMat()" :disabled="insertDataList.matList.length > 0 ? false : true">确认叫料</el-button>
      </div>
    </el-dialog>

    <!-- 库存数量详情 -->
    <el-dialog title="库存数量详情" :visible.sync="whDetailShow" class="fromDialog" :style="$popups.popups(0.8, 0.8)" :close-on-click-modal="false" :show-close="false">
      <div>
        <h-table :style="$popups.harvestRecordStyle(0.63)" :headerCellStyle="mainData.headerCellStyle" :data="whDetailList" :row-class-name="tableRowClassName">
          <el-table-column label="通道编号" prop="whCode" align="center"> </el-table-column>
          <el-table-column label="编号" prop="wiId" align="center"> </el-table-column>
          <el-table-column label="库位编号" prop="lcCode" align="center"> </el-table-column>
          <el-table-column label="物料编号" prop="matCode" align="center"> </el-table-column>
          <el-table-column label="物料描述" prop="matName" align="center"> </el-table-column>
          <el-table-column label="总数量" prop="matQuan" align="center"> </el-table-column>
          <el-table-column label="已分配数" prop="matDistrQuan" align="center"> </el-table-column>
          <el-table-column label="可用数量" prop="matAvaliableQuan" align="center"> </el-table-column>
          <el-table-column label="箱号" prop="boxBarcode" align="center"> </el-table-column>
          <el-table-column label="批次号" prop="batchNo" align="center"> </el-table-column>
          <el-table-column label="库存状态" prop="wiStatus" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.wiStatus == 'NORMAL'">正常</span>
              <span v-if="scope.row.wiStatus == 'FREEZE'">拣货中</span>
              <span v-if="scope.row.wiStatus == 'OVERTIME'">过期</span>
              <span v-if="scope.row.wiStatus == 'DELETE'">作废</span>
              <span v-if="scope.row.wiStatus == 'AGFREEZE'">人工冻结</span>
            </template>
          </el-table-column>
          <el-table-column label="订单编号" prop="orderCode" align="center"> </el-table-column>
          <el-table-column label="入库时间" prop="matCreateTime" align="center"> </el-table-column>
        </h-table>
      </div>
      <div slot="footer" class="dialog-footer footer-bottom">
        <el-button @click="whDetailShow = false" type="info" class="btn-t-info">关 闭</el-button>
      </div>
    </el-dialog>

    <!-- 打印 -->
    <el-dialog title="打印" :visible.sync="printShow" width="1200px" :close-on-click-modal="false">
      <div style="margin-top:20px;margin-left:900px">
        <el-button class="btn-t-info" type="info" @click="printShow = false;printList = [];">取消</el-button>
        <el-button class="btn-t-edit" @click="(print = true), (printShow = false)">打印</el-button>
      </div>
      <v-print :doPrint.sync="print">
        <div id="demo" class="demo">
          <div>
            <div style="margin-left: -1000px; margin-top: 50px">
              {{ timeDate }}
            </div>
            <div style="font-size: 30px;font-weight: 600;margin-top: 20px;text-align: center;color: black;">
              拣货单-滚子（XX）通道
            </div>
            <div class="div" style="margin-top: 10px; font-size: 20px">
              <div>工序：</div>
              <div>班次：</div>
              <div>申请人：{{ person }}</div>
              <div>日期：{{ timeDate }}</div>
              <div>发货（库房）：</div>
              <div>拣货（通道）：</div>
            </div>
            <div class="table">
              <table width="100%" border="1" cellpadding="0" cellspacing="0">
                <tr>
                  <th></th>
                  <th colspan="5"><span style="color:black;">通道下单</span> <br /><span style="font-size: 14.5px;color:black;">下单时间：1）9:00 &nbsp;&nbsp; 2）12：00 &nbsp;&nbsp; 3）17:00 &nbsp;&nbsp; 4）20:00 &nbsp;&nbsp; 5）22:00</span> <br /><span style="font-size: 15px;color:red;">(请在以下时间点前下单，22:00为应急要料时间)</span></th>
                  <th colspan="5"><span style="color:black;">通道接单</span> <br /><span style="font-size: 14.5px;color:black;">查单时间：1）9:00 &nbsp; 2）12：00 &nbsp; 3）17:00 &nbsp; 4）20:00 &nbsp; 5）22:00</span> <br /><span style="font-size: 15px;color:red;">(查单后3小时内通道送物料至通道，三班暂无查单送料安排)</span></th>
                  <th colspan="2" style="color:black;">通道接料</th>
                </tr>
                <tr class="td">
                  <!-- <td style="width: 60px;">序号</td> -->
                  <td colspan="2"><span>型号</span><br /><span>(完整库存编号)</span></td>
                  <td>规值</td>
                  <td>数量</td>
                  <td>备注</td>
                  <td colspan="4">实发库位&数量</td>
                  <td>备注</td>
                  <td>实发数量</td>
                  <td style="width: 80px;">备注</td>
                </tr>
                <tr v-for="(item, index) in printList" :key="index" class="tr">
                  <td>{{ index + 1 }}</td>
                  <td colspan="2">{{ item.matCode }}</td>
                  <td>{{ item.matSpecs }}</td>
                  <td>{{ item.matRealQuan }}</td>
                  <td></td>
                  <td colspan="4">{{ item.matPickQuan }}</td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr class="tr">
                  <td></td>
                  <td colspan="2"></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td colspan="4"></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
              </table>
            </div>
          </div>
        </div>
      </v-print>
      <div style="margin-top: 50px;height:70px">
      </div>
    </el-dialog>



    <!-- 外协详情-->
    <el-dialog title="外协详情" :visible.sync="detailsDialogShow" class="fromDialog" :style="$popups.popups(0.8,0.9)" :close-on-click-modal="false" :show-close="false">
      <h-table :headerCellStyle="mainData.headerCellStyle" :style="$popups.harvestRecordStyle(0.75)" :data="outsourceLists" @selectionChange="checkboxDet">
        <el-table-column label="通道" prop="whCode" align="center">
        </el-table-column>
        <el-table-column label="外协单号" prop="soCode" align="center">
        </el-table-column>
        <el-table-column label="物料编号" prop="matCode" align="center">
        </el-table-column>
        <el-table-column label="物料描述" prop="matName" align="center">
        </el-table-column>
        <!-- <el-table-column label="汇报完成的物料编号" prop="matCheckCode" align="center">
        </el-table-column> -->
        <el-table-column label="数量" prop="boxQuan" palign="center">
        </el-table-column>
        <el-table-column label="外协接收数量" prop="matReceiveQuan" palign="center">
        </el-table-column>
        <el-table-column label="批次" prop="batchNo" align="center">
        </el-table-column>
        <!-- <el-table-column label="原库位" prop="laCode" align="center">
        </el-table-column> -->
        <el-table-column label="外协供应商" prop="laOutsouceCode" align="center">
        </el-table-column>
        <el-table-column label="外协报检库位" prop="laCheckCode" align="center">
        </el-table-column>
        <!-- <el-table-column label="箱号" prop="boxBarcode" align="center">
        </el-table-column> -->
        <!-- <el-table-column label="是否扫描确认" prop="scanFlag" align="center">
            <template slot-scope="scope">
                <div v-if="scope.row.scanFlag == false">否</div>
                <div v-if="scope.row.scanFlag == true ">是</div>
            </template>
        </el-table-column>
        <el-table-column label="扫描接收人" prop="receivePersonNumber" palign="center">
        </el-table-column>
        <el-table-column label="供应商账号" prop="supplyNumber" palign="center">
        </el-table-column> -->
      </h-table>
      <div slot="footer" class="dialog-footer footer-bottom">
        <el-button @click="dialogClose" type="info" class="btn-t-info">关 闭</el-button>
      </div>
    </el-dialog>


    <el-dialog title="导入" :visible.sync="importInShow" class="fromDialog" :close-on-click-modal="false" :show-close="false" @click.stop :style="$popups.popups(0.8,0.9)">
      <div class="uploader-div" >
        <el-upload
            :action="action"
            :file-list="fileList"
            :limit="1"
            multiple
            :accept="accept"
            :before-upload="handleBeforeUpload"
            :on-error="handleUploadError"
            :on-exceed="handleExceed"
            :on-success="handleUploadSuccess"
            :on-change="handChange"
            :http-request="httpRequest"
            :show-file-list="true"
            :auto-upload="false"
            class="upload-file-uploader"
            ref="upload"
        >
          <!-- 上传按钮 -->
          <el-button slot="trigger" size="mini" type="primary">选取文件</el-button>
          <el-button style="margin-left: 10px;" :disabled="fileList.length < 1" size="small" type="success" @click="submitUpload">上传到服务器</el-button>
          <!-- <el-button  @click="rePrintBarcode()" class="btn-t-edit">标签打印</el-button> -->
        </el-upload>
      </div>
      <div slot="footer" class="dialog-footer footer-bottom">
        <el-button @click="importInShow = false" type="info" class="btn-t-info">取 消</el-button>
      </div>
    </el-dialog>


    <!-- 工单同步 -->
    <el-dialog title="工单同步" :visible.sync="isReceivingDetails" class="fromDialog" :style="$popups.popups(0.2, 0.25)" :close-on-click-modal="false" :show-close="false" @click.stop>
      <el-form label-position="right" label-width="80px">
        <el-form-item label="工单编号" prop="tableOrderCode" class="EL-Form-Item">
          <el-input v-model="tableOrderCode" placeholder="请输入"> </el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer footer-bottom">
        <el-button @click="isReceivingDetails = false" class="btn-t-info">取 消</el-button>
        <el-button @click="synchronization()" class="btn-t-edit">确 认</el-button>
      </span>
    </el-dialog>

  </div>
</template>
<style>
.el-table .success-row {
  color: #ff0000;
}
</style>
<script>
import vPrint from "syl-vue-printer";
import moment from "moment";
export default {
  name: "ProductionCall",
  components: {
    vPrint,
  },
  data() {
    return {
      printObj: {
        id: "demo",
        popTitle: "",
      },
      importInShow: false,
      accept: '',
      fileList: [],
      action: 'action',
      // 大小限制(MB)
      fileSize: 20,
      // 文件类型
      fileType:  ".xlsx",
      // 是否显示提示
      isShowTip: {
        type: Boolean,
        default: true
      },
      importData: {
        data: [],
        pageNum: 1,
        pageSize: 500000,
        total: 0,
        printTwo: false,
        headerCellStyle: () => {
          return "background-color: #1f6cec";
        },
      },
      outsourceLists:[],
      mainData: {
        data: [],
        nowPage: 1,
        pageSize: 50,
        total: 0,
        headerCellStyle: () => {
          return "background-color: #1f6cec";
        },
      },
      // 筛选条件
      mainSearch: {
        fcCode: localStorage.getItem("fcCode") || "", // 工厂编号
        whCode: localStorage.getItem("whCode") || "", //通道编号
        pmCode: "", //	生产叫料编号
        opCode: "", //	生产工单编号
        prodCode: "", //	物料编号
        matCode: "", //	物料编号
        status: "PICK,PICKING,PICKCOMPLETE", //	状态
        boxBarcode:"",
        soCode:"",
        soStatus:"20,80",
        date: [],
      },
      laCodeList:[],
      //多选
      checkListMain: [],
      //弹出框
      dialogShow: false,
      insertData: {
        fcCode: localStorage.getItem("fcCode") || "",
        whCode: localStorage.getItem("whCode") || "",
        requireTime: "", //需求时间
        topFlag: false, //是否紧急
        topMessage: "",
        pmType: "MATERIAL", //叫料方式
        opCode: "",
        prodCode: "", //成品编号
        matCode: "",
        jiaoliaoQuan: "",
        jihuaquan: "",
        matSpecsFlag: true, //是否区分分差
        requireOrder: "", //需求订单
        whArea: "",
        shift: "",
        materialType:"",
        emailFlag:"",
        wxFlag:"0",
        wxCode:"",
      },
      insertDataList: {
        orderList: [],
        resultList: [], //原因
        warehouseAreaList: [],
        bomList: [],
        matList: [],
      },
      loading: false, //加载中

      factoryList: [],
      factoryData: {},
      warehouseList: [],
      warehouseData: {},
      checkListDet:[],
      logContent: "", //操作日志-内容
      logRemarks: "", //操作日志-备注
      detailsDialogShow:false,
      person: localStorage.getItem("user"),
      personNumber: localStorage.getItem("empNumber"),

      downloadLoading: false, //下载中
      insertStockProductMats: false,

      //打印
      print: false,
      printShow: false,
      printList: [],
      timeDate: "",

      matSortList: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      // 物料列表
      materialList: [],
      // 输入框延时加载
      isSetTimeout: null,

      //库存数量详情
      whDetailList: [],
      whDetailShow: false,

      //工单窗口
      isReceivingDetails: false,
      //工单编号
      tableOrderCode: "",
    };
  },
  watch: {
    mainSearch: {
      handler(newVal) {
        clearTimeout(this.isSetTimeout);
        this.isSetTimeout = setTimeout(() => {
          this.mainData.nowPage = 1;
          this.getTableData(newVal);
        }, 1000);
      },
      deep: true,
    },
  },

  computed: {
    pickerOptions() {
      let _this = this;
      return {
        disabledDate(time) {
          if (_this.mainSearch.date[0]) {
            return time.getTime() < new Date(_this.mainSearch.date[0]);
          }
        },
      };
    },
    pickerOptions0() {
      let _this = this;
      return {
        disabledDate(time) {
          if (_this.mainSearch.date[1]) {
            return time.getTime() > new Date(_this.mainSearch.date[1]);
          }
        },
      };
    },
  },

  activated() {
    // 从页面跳转传值
    let pmCode = this.$route.query.pmCode;
    if (pmCode) {
      this.mainSearch.date = [];
      this.mainSearch.pmCode = pmCode;
    } else {
      //添加默认时间
      this.mainSearch.date = [];
      this.mainSearch.date.push(moment().subtract("d", 0).format("YYYY-MM-DD"));
      this.mainSearch.date.push(moment().add("d", 1).format("YYYY-MM-DD"));
    }
    this.getMaterial();
    this.getWarehouse();
    this.getFactoryAll();
    this.getlaCode();
    /* 获取首页的数据 */
  },
  methods: {
    httpRequest(param) {

      var formData = new FormData();
      formData.append("file", param.file);
      this.$http
          .request({
            url: "/api/stockProduceMat/importStockProductMatOutsource/" + this.person + "/" + this.personNumber + "/" ,
            method: "POST",
            headers: {
              "Content-Type": "multipart/form-data",
              "X-Auth-Token": localStorage.getItem('token')
            },
            showLoading: true,
            data: formData,
          })
          .then((res) => {
            if (res.status === 100) {
              this.importData.data = res.data.list || [];
              this.$notify({
                message: "上传成功!",
                type: "success",
              });
              this.getTableData();
            } else {
              this.$notify({
                message: res.message,
                type: "danger",
              });
            }
          });

    },

    // 上传前校检格式和大小
    handleBeforeUpload(file) {
      // 校检文件类型
      if (this.fileType) {
        let fileExtension = "";
        if (file.name.lastIndexOf(".") > -1) {
          fileExtension = file.name.slice(file.name.lastIndexOf("."));
        }
        const isTypeOk =  this.fileType.indexOf(fileExtension) != -1 ? true:false;

        if (!isTypeOk) {
          this.$message.error(`文件格式不正确, 请上传${this.fileType}格式文件!`);
          return false;
        }
      }
      // 校检文件大小
      if (this.fileSize) {
        const isLt = file.size / 1024 / 1024 < this.fileSize;
        if (!isLt) {
          this.$message.error(`上传文件大小不能超过 ${this.fileSize} MB!`);
          return false;
        }
      }
      return true;
    },
    // 获取文件名称
    getFileName(name) {
      if (name.lastIndexOf("/") > -1) {
        return name.slice(name.lastIndexOf("/") + 1).toLowerCase();
      } else {
        return "";
      }
    },
    /** 手动提交上传 */
    submitUpload() {
      if (this.fileList.length <= 0) {
        return false
      }
      this.$refs.upload.submit()
    },
    /** 文件状态改变时调用 */
    handChange(file, fileList) {
      this.fileList = fileList
    },
    // 删除文件
    handleDelete(index) {
      this.fileList.splice(index, 1);
    },
    // 文件个数超出
    handleExceed() {
      this.$message.error(`只允许上传1个文件`);
    },
    // 上传失败
    handleUploadError(err) {
      this.$message.error("上传失败, 请重试");

    },

    // 上传成功回调

    handleUploadSuccess(res, file) {
      this.$message.success("上传成功");
      this.getTableData();
      this.cancel()

    },
    //同步工单
    synchronization() {
      if (this.tableOrderCode == "" || this.tableOrderCode.length != 7) {
        this.$message({
          message: "请填写正确的工单编号!",
          type: "warning",
        });
        return;
      }
      this.$http
        .request({
          url: "/api/order/opCodeSynchronization",
          method: "POST",
          showLoading: true,
          params: {
            opCode: this.tableOrderCode,
          },
        })
        .then((res) => {
          if (res.status == 100) {
            this.isReceivingDetails = false;
            this.tableOrderCode = "";
            this.$message({
              message: "同步成功",
              type: "success",
            });
          } else {
            this.$message({
              message: res.message,
              type: "error",
            });
          }
        });
    },
    //扫描取消
    dialogClose() {
      this.detailsDialogShow = false;
      this.outsourceLists = [];
      this.getTableData();
    },


    //关闭外协单
    closeOutsourcing() {
      if (this.checkListMain.length == 0) {
        this.$message({
          type: "warning",
          message: "请选择外协单！",
        });
        return
      }
      const res = this.checkListMain.every(e => {
        if (e.soStatus != "20") {
          this.$message({
            type: "warning",
            message: "创建状态下的外协单才能关闭！",
          });
          return false;
        } else {
          return true;
        }
      })
      if (res == false) {
        return false;
      }

      this.$confirm("是否关闭该外协单? ", "提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      })
          .then(() => {
            this.$http
                .request({
                  url: "/api/outsource/closeOutsourcing",
                  method: "POST",
                  data: this.checkListMain,
                  params: {
                    person: localStorage.getItem("user"),
                    personNumber: localStorage.getItem("empNumber"),
                  }
                })
                .then((res) => {
                  if (res.status == 100) {
                    this.$notify({
                      title: "成功",
                      message: "操作成功！",
                      type: "success",
                    });
                    this.logRemarks = "outsource：关闭外协单成功";
                  } else {
                    this.$notify.error({
                      title: "失败",
                      message: res.message,
                    });
                    this.logContent = JSON.stringify(this.checkListMain);
                    this.systemLog();
                    this.logRemarks = "outsource：关闭外协单成功";
                  }
                  this.getTableData();
                });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消",
            });
          });
    },
    //获取详情
    getOutsourceDetail(soCode,status) {
      this.$http
          .request({
            url: "/api/outsource/getOutsourceDetail",
            method: "GET",
            params: {
              soCode: soCode || null,
              statusList:status || null
            },
          })
          .then((resp) => {
            if (resp.status == 100) {
              this.outsourceLists = resp.data.list || [];
            }
          })
          .catch((error) => {
            this.$message({
              message: "操作失败",
              type: "warning",
            });
          });
    },
    // 节流搜索
    saveSearch() {
      if (window.lazy) window.clearTimeout(window.lazy);
      window.lazy = window.setTimeout(() => {
        this.mainData.nowPage = 1;
        this.getTableData();
      }, 1000);
    },

    tableRowClassName({ row }) {
      if (this.insertData.pmType == "ORDER" && row.matRealQuan - 0 + row.matCallQuan > row.matCountQuan) {
        return "success-row";
      }
    },

    getTableData() {
      this.$http
          .request({
            url: "/api/outsource/getOutsourceData",
            method: "GET",
            params: {
              pageNum: this.mainSearch.pageNum || null,
              pageSize: this.mainSearch.pageSize || null,
              soCode: this.mainSearch.soCode || null,
              matCode: this.mainSearch.matCode || null,
              boxBarcode: this.mainSearch.boxBarcode || null,
              fcCode: this.mainSearch.fcCode || null,
              person: this.mainSearch.person || null,
              laCode: this.mainSearch.laCode || null,
              whCode: this.mainSearch.whCode || null,
              soStatus: this.mainSearch.soStatus || null,
              wxCode: this.mainSearch.wxCode || null,
            },
          })
        .then((res) => {
          if (res.status == 100) {
            this.mainData.data = res.data.list;
            this.mainData.total = res.data.total;
          } else {
            this.$message.error("错误");
          }
        });
    },
    checkboxDet(val) {
      this.checkListDet = val;
    },

    /**
     * 查询最近的工单
     */
    getOrderProductList() {
      this.$http
        .request({
          url: "/api/orderProduct/getOrderProductList",
          method: "GET",
          params: {
            whCode: this.insertData.whCode || null,
            fcCode: this.insertData.fcCode || null, //	当前登录的工厂
          },
        })
        .then((res) => {
          if (res.status == 100) {
            this.insertDataList.orderList = res.data;
            if (this.insertData.pmType == "ORDER") {
              this.insertData.opCode = "";
              this.insertData.jihuaquan = "";
              this.insertData.jiaoliaoQuan = "";
            }
          } else {
            this.$message.error("错误");
          }
        });
    },

    changeOrder(opCode) {
      let orderInfo = this.insertDataList.orderList.find((i) => i.opCode == opCode);
      this.insertData.fcCode = orderInfo.fcCode;
      this.insertData.whCode = orderInfo.whCode;
      this.insertData.prodCode = orderInfo.matCode;
      this.insertData.jiaoliaoQuan = orderInfo.matQuan;
      this.insertData.jihuaquan = orderInfo.matQuan;
    },
    /**
     * 当前所有BOM信息
     */
    getProdList() {
      this.$http
        .request({
          url: "/api/bom/getProdList",
          method: "GET",
          params: {
            fcCode: localStorage.getItem("fcCode") || "", // 当前登录的工厂
          },
        })
        .then((res) => {
          if (res.status == 100) {
            this.insertDataList.bomList = res.data;
          } else {
            this.$message.error("错误");
          }
        });
    },

    topMessages(topFlag) {
      if (topFlag == false) {
        this.insertData.topMessage = "";
      } else {
        this.getWarnType();
      }
    },
    /**
     * 当前工厂的通道信息
     */
    getWarehouse() {
      this.$http
        .request({
          url: "/api/warehouse/getWarehouse",
          method: "GET",
          params: {
            fcCode: localStorage.getItem("fcCode") || null,
          },
        })
        .then((resp) => {
          if (resp.status == 100) {
            this.warehouseList = resp.data.list || [];
          }
        })
        .catch((error) => {});
    },
    /**
     * 当前工厂的库区信息
     */
    getWhAreaList() {
      this.$http
          .request({
            url: "/api/warehouse/getWhAreaList",
            method: "GET",
            params: {
              fcCode: localStorage.getItem("fcCode") || null,
            },
          })
          .then((resp) => {
            if (resp.status == 100) {
              this.insertDataList.warehouseAreaList = resp.data || [];
            }
          })
          .catch((error) => {});
    },
    changeWhCode() {
      if (this.insertData.pmType == "ORDER") {
        this.getOrderProductList(); //查询最近的工单
      }

      this.warehouseData = this.warehouseList.find(item => item.whCode == this.insertData.whCode)
      this.insertData.whArea = this.warehouseData.whArea || ""
    },
    //物料列表
    getMaterial() {
      this.$http
        .request({
          url: "/api/material/getMaterialAll",
          method: "GET",
          params: {
            fcCode: this.insertData.fcCode || null,
            mtCode: this.insertData.matCode || null,
            pageNum: 1,
            pageSize: 1000,
          },
        })
        .then((res) => {
          if (res.status == 100) {
            this.materialList = res.data.list;
          } else {
            this.$message.error("错误");
          }
        });
    },
    /* 远程搜索物料编号 */
    remoteMethod(query) {
      this.loading = true;
      if (query != "") {
        this.insertData.matCode = query;
        this.getMaterial();
      } else {
        this.insertData.matCode = "";
        this.getMaterial();
      }
      setTimeout(() => {
        this.loading = false;
        if (this.materialList != undefined) {
          this.materialList = this.materialList.filter((item) => {
            return item.mtCode.toLowerCase().indexOf(query.toLowerCase()) > -1;
          });
        }
      }, 200);
    },
    /**
     * 新增叫料
     */
    insertdialogShow() {
      this.insertData.fcCode = localStorage.getItem("fcCode") || "";
      this.insertData.whCode = localStorage.getItem("whCode") || "";
      this.insertData.requireTime = moment().add("hour", 4).format("YYYY-MM-DD HH:mm:ss"); //需求时间
      this.insertData.pmType = "ORDER"; //工单/BOM/物料
      this.dialogShow = true;
      this.factoryData = this.factoryList.find(item => item.fcCode == this.insertData.fcCode)
      this.warehouseData = this.warehouseList.find(item => item.whCode == this.insertData.whCode)
      this.insertData.whArea = this.warehouseData.whArea || ""

      this.changePmType();
      this.getWarehouse();
      this.getWhAreaList();
    },
    /**
     * 判断是否紧急
     */
    topFunction() {
      let dateBegin = new Date();
      let dateEnd = new Date(this.insertData.requireTime);
      let dateDiff = dateEnd.getTime() - dateBegin.getTime(); //时间差
      let minutes = Math.floor(dateDiff / (60 * 1000)); //计算相差分钟

      if (this.factoryData.urgentTime >= minutes) {
        this.insertData.topFlag = true;
        this.getWarnType();
      } else {
        this.insertData.topFlag = false;
        this.insertData.topMessage = "";
      }
    },

    insertdialogClose() {
      this.dialogShow = false;
      this.insertData = {
        fcCode: localStorage.getItem("fcCode") || "",
        whCode: localStorage.getItem("whCode") || "",
        requireTime: "", //需求时间
        topFlag: false, //是否紧急
        topMessage: "",
        pmType: "ORDER", //叫料方式
        opCode: "",
        prodCode: "", //成品编号
        matCode: "",
        jiaoliaoQuan: "",
        jihuaquan: "",
        matSpecsFlag: true, //是否区分分差
        requireOrder: "", //需求订单
        whArea: "",
      };
      this.insertDataList = {
        orderList: [],
        resultList: [], //原因
        warehouseAreaList: [],
        bomList: [],
        matList: [],
      }
    },

    /**
     * 叫料方式
     */
    changePmType() {
      if (this.insertData.pmType == "ORDER") {
        this.getOrderProductList();
      } else if (this.insertData.pmType == "BOM") {
        this.getProdList();
      } else if (this.insertData.pmType == "MATERIAL") {
        this.getMaterial();
      }
      this.insertData.opCode = "";
      this.insertData.prodCode = "";
      this.insertData.matCode = "";
      this.insertData.jiaoliaoQuan = 1;
      this.insertDataList.matList = [];
    },
    getBomList() {
      if (this.insertData.whCode == "" || this.insertData.whCode == null) {
        this.$message({
          type: "warning",
          message: "请选择通道！",
        });
        return;
      }
      // if (this.insertData.pmType == "ORDER" && this.insertData.opCode == "") {
      //   this.$message({
      //     type: "warning",
      //     message: "请选择工单！",
      //   });
      //   return;
      // }
      if (this.insertData.pmType == "BOM" && (this.insertData.prodCode == "" || this.insertData.whCode == "" || this.insertData.jiaoliaoQuan == "")) {
        this.$message({
          type: "warning",
          message: "BOM、通道及数量都不能为空！",
        });
        return;
      }
      if (this.insertData.requireTime == "" || this.insertData.requireTime == null) {
        this.$message({
          type: "warning",
          message: "请选择需求时间！",
        });
        return;
      }
      if (this.insertData.materialType == "" || this.insertData.materialType == null) {
        this.$message({
          type: "warning",
          message: "请选择物料类型！",
        });
        return;
      }
      if (this.insertData.wxCode == "" || this.insertData.wxCode == null) {
        this.$message({
          type: "warning",
          message: "请选择供应商！",
        });
        return;
      }
      if (this.insertData.pmType != "MATERIAL" ) {
        // this.$message({
        //   type: "warning",
        //   message: "请选择物料叫料！",
        // });
        // return;
      }


      if (this.insertData.pmType != "MATERIAL") {
        this.insertDataList.matList = [];
      }

      //如果工单存在叫料数量则按BOM进行处理
      var number = 0;
      if (this.insertData.jiaoliaoQuan > 0) {
        number = this.insertData.jiaoliaoQuan;
      }
			let whCodes = this.insertData.whCode;
			if (this.insertData.fcCode == 'SXC') {
				whCodes = whCodes + "";
			}

      this.$http
        .request({
          url: "/api/stockProduceMat/getOrderProductBomList",
          method: "GET",
          params: {
            fcCode: this.insertData.fcCode || null, //	当前登录的工厂
            opCode: this.insertData.opCode || null,
            prodCode: this.insertData.prodCode || null,
            whCode: whCodes || null,
            whArea: this.insertData.whArea || null,
            matCode: this.insertData.matCode || null,
            number: number,
            matSpecsFlag: this.insertData.matSpecsFlag || false,
            requireOrder: this.insertData.requireOrder || null,
            mtTypeName:this.insertData.materialType,
            wxFlag:this.insertData.wxFlag,
          },
        })
        .then((res) => {
          if (res.status == 100) {
            let dataMat = res.data || null;

            for (let i in dataMat) {
              dataMat[i].index = this.insertDataList.matList.length;

              if (this.insertData.pmType == "BOM" || this.insertData.pmType == "MATERIAL") {
                // dataMat[i].matRealQuan = this.insertData.jiaoliaoQuan * dataMat[i].bomQuan;
                dataMat[i].matRealQuan = '';
                if (dataMat[i].matRealQuan < 0) {
                  dataMat[i].matRealQuan = '';
                }

                dataMat[i].matQuan = this.insertData.jiaoliaoQuan * dataMat[i].bomQuan;
                if (dataMat[i].matQuan < 0) {
                  dataMat[i].matQuan = 0;
                }
              } else if (this.insertData.pmType == "ORDER") {
                if (this.insertData.jiaoliaoQuan != this.insertData.jihuaquan) {
                  // dataMat[i].matRealQuan = this.insertData.jiaoliaoQuan * dataMat[i].bomQuan;
                  dataMat[i].matRealQuan = '';
                  if (dataMat[i].matRealQuan < 0) {
                    dataMat[i].matRealQuan = 0;
                  }
                } else {
                  // dataMat[i].matRealQuan = dataMat[i].matCountQuan - dataMat[i].matCallQuan;
                  dataMat[i].matRealQuan = '';
                  if (dataMat[i].matRealQuan < 0) {
                    dataMat[i].matRealQuan = 0;
                  }
                }

                dataMat[i].matQuan = dataMat[i].matCountQuan - dataMat[i].matCallQuan;
                if (dataMat[i].matQuan < 0) {
                  dataMat[i].matQuan = 0;
                }
              }

              dataMat[i].requireTime = this.insertData.requireTime;
              dataMat[i].topFlag = this.insertData.topFlag;
              dataMat[i].topMessage = this.insertData.topMessage;
              dataMat[i].requireOrder = this.insertData.requireOrder || "";

              dataMat[i].matFcCode = localStorage.getItem("fcCode") || "";
              let putFlag = true;
              // if(this.insertDataList.matList.length > 0){
              //   putFlag = false;
              //   this.insertDataList.matList.forEach((element) => {
              //
              //     if(element.matSpecs != dataMat[i].matSpecs && element.matCode!=dataMat[i].matCode){
              //       putFlag = true;
              //
              //     }else  if(element.matSpecs != dataMat[i].matSpecs && element.matCode ==dataMat[i].matCode){
              //       putFlag = true;
              //     }
              //
              //   });
              // }
              if(putFlag){
                this.insertDataList.matList.push(dataMat[i]);
              }

            }
          } else {
            this.$message.error(res.message);
          }
        });
    },
    delList(id) {
      var index = this.insertDataList.matList.findIndex((item) => {
        if (item.index == id) {
          return true;
        }
      });
      this.insertDataList.matList.splice(index, 1);
    },

    /**
     * 确认叫料
     */
    insertStockProductMat() {
      if (this.insertDataList.matList.length == 0) {
        this.$message({
          type: "warning",
          message: "没有物料",
        });
        return;
      }

      //判断当前数量是否超过物料需求数量
      var matCode = "";

      for (var index in this.insertDataList.matList) {
        var row = this.insertDataList.matList[index];
        if (row.matCountQuan - row.matCallQuan < row.matRealQuan) {
          if (matCode == "") {
            matCode = row.matCode;
          } else {
            matCode += "," + row.matCode;
          }
        }
        // if (row.matRealQuan == 0) {
        //   this.$message({
        //     type: "warning",
        //     message: "实际需求数量不能为0!",
        //   });
        //   return;
        // }
        if (row.matRealQuan > row.whQuan) {
          this.$message({
            type: "warning",
            message: "实际需求数量不能超过当前库存!",
          });
          return;
        }
      }


      

      // if (this.insertDataList.matList.length > 10) {
      //   this.$message({
      //     type: "warning",
      //     message: "叫料明细不能超过10条",
      //   });
      //   return;
      // }

      var message = "是否确认叫料?";
      if (matCode != "") {
        message = "当前叫料数量超过工单数量" + matCode;
      }
      this.$confirm(message, "提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.insertStockProductMats = true;
          var matList = [];
          this.insertDataList.matList.forEach((element) => {
            element.loginWhCode = localStorage.getItem("whCode") || ''
            if (element.matSpecsAndWhQuan != undefined) {
              element.whQuan = element.specsList[element.matSpecsAndWhQuan].whQuan;
              element.matSpecs = element.specsList[element.matSpecsAndWhQuan].matSpecs;
            }

            if (element.matRealQuan > 0) {
              matList.push(element);
            }

          });
          if (matList.length == 0) {
            this.$message({
              type: "warning",
              message: "实际需求数量不能为0!",
            });
            this.insertStockProductMats = false;
            return;
          }
          if(matList.length > 10){
            this.$message({
              type: "warning",
              message: "叫料明细不能超过10条",
            });
            this.insertStockProductMats = false;
            return;
          }

          this.$http
            .request({
              url: "/api/stockProduceMat/insertStockProductMatOutsource/" + this.person + "/" + this.personNumber + "/" + this.insertData.pmType,
              method: "POST",
              showLoading: true,
              data: matList,
              params: {
                whCode: this.insertData.whCode,
                shift: this.insertData.shift,
                materialType: this.insertData.materialType,
                emailFlag: this.insertData.emailFlag,
                wxFlag: this.insertData.wxFlag,
                wxCode: this.insertData.wxCode,
              },
            })
            .then((resp) => {
              if (resp.status == 100) {
                this.$message({
                  message: "操作成功",
                  type: "success",
                });
                this.logRemarks = "stockProduceMat：叫料成功";
                this.insertdialogClose();
                this.getTableData();
              } else {
                this.$message({
                  message: resp.message,
                  type: "error",
                });
                this.logRemarks = "stockProduceMat：叫料失败";
              }
              this.insertStockProductMats = false;
              this.logContent = JSON.stringify(this.insertDataList.matList);
              this.systemLog();
            })
            .catch((error) => {
              this.insertStockProductMats = false;
              this.$message({
                message: "操作失败",
                type: "error",
              });
            });
        })
        .catch(() => {
          this.insertStockProductMats = false;
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },

    /**
     * 禁选
     */
    checkboxMain(row, rowIndex) {
      if (row.status == "CREATE") {
        return true; // 不禁用
      } else {
        return false; // 禁用
      }
    },
    /**
     * 全选
     */
    selectAllMain(val) {
      this.checkListMain = val;
    },

    /**
     * 重置
     */
    resetMain() {
      this.mainSearch = {
        fcCode: localStorage.getItem("fcCode") || "", // 工厂编号
        whCode: localStorage.getItem("whCode") || "", //通道编号
        pmCode: "", //	生产叫料编号
        opCode: "", //	生产工单编号
        prodCode: "", //	物料编号
        matCode: "", //	物料编号
        status: "PICK,PICKING,PICKCOMPLETE", //	状态
        date: [],
      };
    },

    /**
     * 紧急原因
     * */
    getWarnType() {
      this.$http
        .request({
          url: "/api/warnType/getWarnType",
          method: "GET",
          params: {
            fcCode: this.insertData.fcCode || null,
            wtType: "10",
          },
        })
        .then((resp) => {
          if (resp.status == 100) {
            this.insertDataList.resultList = resp.data;
          }
        })
        .catch((error) => {});
    },
    //获取数据
    getFactoryAll() {
      this.$http
        .request({
          url: "/api/factory/getFactoryAll",
          method: "GET",
          params: {},
        })
        .then((resp) => {
          if (resp.status == 100) {
            this.factoryList = resp.data.list || [];
          }
        })
        .catch((error) => {
          this.loading++;
        });
    },
    //表格导出
    //表格导出
    downLoadFile() {
      this.downloadLoading = true;
      let soCode = "";
      this.mainData.data.forEach((element) => {
        if(soCode.indexOf(element.soCode) == -1){
          soCode = soCode + element.soCode + ",";
        }
      });
      this.$http
          .request({
            url: "/api/outsource/getOutsourceDetail",
            method: "GET",
            params: {
              soCode: soCode || null,
            },
          }).then((resp) => {
        resp.status == 100 ? this.downLoad2(resp.data.list || []) : this.$notify.error({
          message: '查询失败'
        });
      })
    },
    downLoad2(list) {
      import('@/libs/Export2Excel').then(excel => {
        const tHeader = ['通道', '外协单号', '物料编号', '物料描述', '汇报完成的物料编号', '箱数','接收数量', '批次', '外协库位','外协报检库位', '箱号',
          '操作人', '工号', '更新时间', '创建时间'
        ]
        const filterVal = ['whCode', 'soCode', 'matCode', 'matName','matCheckCode',  'boxQuan','matReceiveQuan', 'batchNo',  'laOutsouceCode', 'laCheckCode', 'boxBarcode',
          'person', 'personNumber', 'updateTime', 'createTime'
        ]
        const data = this.formatJson(filterVal, list)
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: '外协记录数据'
        })
        this.logContent = "导出"
        this.logRemarks = "stock_outsource：导出外协记录数据"
        this.systemLog();
        this.downloadLoading = false
      })
    },
    //获取WX库位
    getlaCode() {
      this.$http
          .request({
            url: "/api/location/getLocationAll",
            method: "GET",
            params: {
              lcType: "WX",
              fcCode: localStorage.getItem("fcCode") || "",
            },
          })
          .then((resp) => {
            if (resp.status == 100) {
              this.laCodeList = resp.data.list || [];
            }
          })
          .catch((error) => {
            this.loading++;
          });
    },
    downLoad(list) {
      import("@/libs/Export2Excel").then((excel) => {
        list.forEach(function(c) {
          if (c.status == "CREATE") {
            c["status"] = "创建";
          } else if (c.status == "PICK") {
            c["status"] = "待拣货";
          } else if (c.status == "PICKING") {
            c["status"] = "拣货中";
          } else if (c.status == "PICKCOMPLETE") {
            c["status"] = "拣货完成";
          } else if (c.status == "CHECKOUT") {
            c["status"] = "配送出库";
          } else if (c.status == "COMPLETE") {
            c["status"] = "完成";
          } else if (c.status == "CLOSE") {
            c["status"] = "关闭";
          }

          if (c.topFlag == false) {
            c["topFlag"] = "否";
          } else if (c.topFlag == true) {
            c["topFlag"] = "是";
          }
        });
        const tHeader = ["通道编号", "成品编号", "物料编号", "物料描述", "物料需求数量", "已发数量", "规值", "生产工单", "生产叫料编号", "需求时间", "状态", "是否紧急", "紧急原因", "最小包装量", "操作人", "创建时间", "更新时间"];
        const filterVal = ["whCode", "produceCode", "matCode", "matName", "matRealQuan", "matPickQuan", "matSpecs", "opCode", "pmCode", "requireTime", "status", "topFlag", "topMessage", "minBoxNum", "person", "createTime", "updateTime"];
        const data = this.formatJson(filterVal, list);
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: "生产叫料",
        });
        this.logContent = "导出";
        this.logRemarks = "stock_product：导出生产叫料记录";
        this.systemLog();
        this.downloadLoading = false;
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },

    prints() {
      if (this.checkListMain.length == 0) {
        this.$message({
          message: "请选择打印单！",
          type: "warning",
        });
        return;
      }
      let num = 0;
      this.checkListMain.forEach((item) => {
        if (item.status == "PICKING") {
          num += 1;
        }
      });
      this.printList = this.checkListMain;
      this.printShow = true;
      this.getTime();
    },

    /**
     * 获取当前时间
     * 格式YYYY-MM-DD
     */
    getTime() {
      var date = new Date();
      var seperator1 = "/";
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      this.timeDate = year + seperator1 + month + seperator1 + strDate;
    },
    printObjList() {
      let code = [];
      for (let i in this.printList) {
        code.push(this.printList[i].pmCode);
      }
      let stringCode = code.join(",");
      this.$http
        .request({
          url: "api/stockPrintDocument/insertStockPrintDocument",
          method: "POST",
          showLoading: true,
          params: {
            operaCode: stringCode,
            operaType: "10",
            fcCode: localStorage.getItem("fcCode") || "",
            person: localStorage.getItem("user"),
            personNumber: localStorage.getItem("empNumber"),
          },
        })
        .then((resp) => {})
        .catch((error) => {});
    },

    /**
     * 关闭-叫料单
     */
    closeMatByPick(rowItem) {
      this.$http
        .request({
          url: "/api/stockProduceMat/closeMatByPick",
          method: "",
          params: {
            pmId: rowItem.pmId,
          },
        })
        .then((resp) => {
          if (resp.status == 100) {
            let message = "";
            if (resp.data) {
              message = "当前叫料单拣货中，不能关闭?";
              this.$message({
                message: message,
                type: "error",
              });
              return;
            } else {
              message = "是否关闭当前叫料单：" + rowItem.pmCode + "-" + rowItem.pmId + "?";
            }
            this.closeProductionCall(message, rowItem);
          } else {
            this.$message({
              message: resp.message,
              type: "error",
            });
          }
        })
        .catch((error) => {
          this.$message({
            message: "操作失败",
            type: "error",
          });
        });
    },
    closeProductionCall(message, rowItem) {
      this.$confirm(message, "提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$http
            .request({
              url: "/api/stockProduceMat/closeStockProductMat",
              method: "POST",
              showLoading: true,
              params: {
                pmId: rowItem.pmId,
                person: localStorage.getItem("user"),
                personNumber: localStorage.getItem("empNumber"),
                type: "ordinary", //普通关闭
                //type: 'force', //强制关闭
              },
            })
            .then((resp) => {
              if (resp.status == 100) {
                this.$message({
                  message: "操作成功",
                  type: "success",
                });
                this.logRemarks = "stockProduceMat：叫料单关闭成功";
              } else {
                this.$message({
                  message: resp.message,
                  type: "error",
                });
                this.logRemarks = "stockProduceMat：叫料单关闭失败";
              }
              this.logContent = JSON.stringify("pmCode：" + rowItem.pmCode);
              this.systemLog();
              this.getTableData();
            })
            .catch((error) => {
              this.$message({
                message: "操作失败",
                type: "error",
              });
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },

    getWhDetails(row) {
      this.whDetailShow = true;
      this.whDetailList = [];

      this.$http
        .request({
          url: "/api/stockProduceMat/getWhCountDetails",
          method: "",
          params: {
            // fcCode: row.fcCode || null,
            fcCode: this.insertData.fcCode || null,
            whCode: row.whCode || null,
            whArea: this.insertData.whArea || null,
            matCode: row.matCode || null,
            matSpecs: row.matSpecs || null,
            requireOrder: this.insertData.requireOrder || null,
          },
        })
        .then((resp) => {
          if (resp.status == 100) {
            this.whDetailList = resp.data || null;
          } else {
            this.$message({
              message: resp.message,
              type: "error",
            });
          }
        })
        .catch((error) => {
          this.$message({
            message: "操作失败",
            type: "error",
          });
        });
    },

    /**
     * 操作日志
     */
    systemLog() {
      let objData = {
        logType: "生产叫料",
        logContent: this.logRemarks || "",
        //logRemarks: this.logRemarks || "",
        logUser: localStorage.getItem("user") || "",
      };
      this.$http
        .request({
          url: "api/log/insert",
          method: "POST",
          showLoading: true,
          data: objData,
        })
        .then((resp) => {
          this.logContent = "";
          this.logRemarks = "";
          if (resp.status == 100) {
          }
        })
        .catch((error) => {});
    },
  },
};
</script>

<style lang="scss">
.ProductionCall {
  .div div {
    width: 170px;
    height: 50px;
    /* border: 1px solid black; */
    margin-left: 10px;
    margin-top: 10px;
    float: left;
    font-weight: 550;
    font-size: 18px;
    color: black;
  }

  .h-table .el-table {
    .el-table__header {
      table-layout: initial;
      // width: 100% !important;
    }

    //蓝色表头
    thead tr {
      height: 45px;
      color: rgb(0, 0, 0, 0.7);
      background-color: #ddd;
      font-size: 16px;

      th {
        max-width: 60px !important;
        background-color: inherit !important;
        text-align: center;

        div {
          width: 60px;
          display: inline-block;
          // width: 2rem;
        }
      }
    }

    tbody tr {
      td {
        text-align: center;
      }
    }
  }
}

.div div {
  width: 150px;
  height: 30px;
  // border: 1px solid black;
  float: left;
  font-size: 15px;
  font-weight: bold;
  color: black;
  text-align: left;
}

.table td {
  color: black;
  text-align: center;
}

.tr td {
  height: 40px;
}
.redx{
  width: 3px;
  padding-top: 11px;
  padding-left: 14px;
  color: red;
}
</style>
